import classNames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import './Table.scss';
import { TableSkeleton } from './TableSkeleton';
import { ITableProps } from './types';

export class Table extends Component<PropsWithChildren<ITableProps>, {}> {
  public static defaultProps = {
    bordered: true,
    responsive: true,
  };

  public render() {
    const tableClasses = classNames({
      table: true,
      [`table-striped`]: this.props.striped,
      [`table-bordered`]: this.props.bordered,
      [`table-hover`]: this.props.hoverRows,
      [`table-condensed`]: this.props.condensed,
      [`table-numbered`]: this.props.numbered,
    });

    const table = this.props.isDataLoading ? (
      <TableSkeleton />
    ) : (
      <table className={tableClasses} qa-id={this.props['qa-id']}>
        {this.maybeRenderCaption()}
        {this.props.children}
      </table>
    );

    if (this.props.responsive) {
      return <div className={`table-responsive`}>{table}</div>;
    }

    return table;
  }

  private maybeRenderCaption() {
    if (this.props.caption) {
      return <caption>{this.props.caption}</caption>;
    }
    return null;
  }
}

export default Table;
